export default __webpack_public_path__ + "static/media/circleblue.adc258a9.svg";